/** Envuelve una ruta con lazy() en un Suspense que muestra el Spinner mientras el módulo termina de cargar. */
import React, { Suspense, type LazyExoticComponent, type FC } from "react";
import Spinner from "../spinner/Spinner";

const LazyRoute: React.FC<{ component: LazyExoticComponent<FC> }> = ({ component: Component }) => (
  <Suspense fallback={<Spinner />}>
    <Component />
  </Suspense>
);

export default LazyRoute;
